// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { OrganizationalUnit } from "../../../data/app-core/organizational-unit";
import { OrganizationalUnitPerson } from "../../../data/app-core/organizational-unit-person";
import { OrganizationalUnitGroup } from "../../../data/app-core/organizational-unit-group";
import { EnvelopeDocument } from "../base/envelope-document";

export class OrganizationalUnitDocument extends EnvelopeDocument {
	public override Item: OrganizationalUnit = new OrganizationalUnit();
	public Persons: OrganizationalUnitPerson[] = [];
	public Groups: OrganizationalUnitGroup[] = [];
}